import { FormControl, RadioGroup } from '@mui/material';
import { Text } from '../Text/Text';
import { formControlSx, radioGroupSx } from './MoodCheck.style';
import { FormRadio } from '../FormRadio/FormRadio';
import { MOOD_CHECK_RADIOS } from '../../constants/moodCheck';

export const MoodCheck = ({ formik, label, sx }) => (
  <FormControl sx={{ ...formControlSx, ...sx }} fullWidth>
    {label && <Text text={label} />}

    <RadioGroup
      aria-labelledby="mood-check-radios"
      name="mood"
      value={formik.values.mood}
      onChange={formik.handleChange}
      sx={radioGroupSx}
    >
      {MOOD_CHECK_RADIOS.map((m, i) => (
        <FormRadio key={i} value={m.value} icon={m.icon} label={m.label} />
      ))}
    </RadioGroup>
  </FormControl>
);
